<div class="not-found">
  <h1>404</h1>
  <p>Page not found.</p>
  <a href="#/">Go Home</a>
</div>

<style>
  .not-found {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5rem 0;
    text-align: center;
  }
  h1 {
    font-size: 2.5rem;
    color: var(--text-muted);
    margin: 0 0 0.5rem;
  }
  p {
    color: var(--text-secondary);
    margin: 0 0 1rem;
  }
  a {
    color: var(--cyan);
  }
</style>
